if (!customElements.get('color-swatch-switcher')) {
  class ColorSwatchSwitcher extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map();
      this.isSwapping = false;
      this.preloadController = null;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.currentUrl = this.dataset.currentUrl;
      this.swatches = this.querySelectorAll('a.minerva-color-swatch');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', (e) => this.handleClick(e, swatch));
        swatch.addEventListener('mouseenter', () => this.handlePreload(swatch));
        swatch.addEventListener('touchstart', () => this.handlePreload(swatch), { passive: true });
      });

      this._onPopState = (e) => this.handlePopState(e);
      window.addEventListener('popstate', this._onPopState);


    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._onPopState);
    }

    getFetchUrl(targetUrl) {
      const urlObj = new URL(targetUrl, window.location.origin);
      urlObj.searchParams.set('section_id', this.sectionId);
      return urlObj.toString();
    }

    handlePreload(swatch) {
      const url = swatch.getAttribute('href');
      if (!url || this.cache.has(url)) return;
      if (swatch.classList.contains('is-active')) return;

      if (this.preloadController) {
        this.preloadController.abort();
      }
      this.preloadController = new AbortController();

      const fetchUrl = this.getFetchUrl(url);

      fetch(fetchUrl, { signal: this.preloadController.signal })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.text();
        })
        .then((html) => this.cache.set(url, html))
        .catch((err) => {
          if (err.name !== 'AbortError') console.warn('[Minerva] Preload failed:', err);
        });
    }

    async handleClick(e, swatch) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (swatch.classList.contains('is-sold-out') || swatch.classList.contains('is-active') || this.isSwapping) return;

      const targetUrl = swatch.getAttribute('href');
      if (!targetUrl) return;

      this.isSwapping = true;

      // Essendo un CLICK, aggiungiamo la pagina alla cronologia normalmente
      window.history.pushState({ path: targetUrl }, '', targetUrl);

      await this.performSwap(targetUrl);
    }

    async handlePopState(e) {
      const path = e.state?.path || window.location.pathname;
      const swatch = this.querySelector(`a[href="${path}"]`);

      if (swatch && !swatch.classList.contains('is-active')) {
        this.isSwapping = true;
        // Essendo un TASTO BACK, facciamo lo swap ma SENZA aggiornare la cronologia per evitare il loop
        await this.performSwap(path);
      } else if (!swatch) {
        window.location.reload();
      }
    }

    // Cuore unificato dello scambio DOM
    async performSwap(targetUrl) {
      try {
        let html = this.cache.get(targetUrl);
        if (!html) {
          const fetchUrl = this.getFetchUrl(targetUrl);
          const res = await fetch(fetchUrl);
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          html = await res.text();
          this.cache.set(targetUrl, html);
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const currentSection = document.getElementById(`MainProduct-${this.sectionId}`);
        if (!currentSection) throw new Error(`Section container not found`);

        const currentMediaWrapper = currentSection.querySelector('.product__media-wrapper');
        const currentInfoWrapper = currentSection.querySelector('.product__info-wrapper');

        const newSection = doc.getElementById(`MainProduct-${this.sectionId}`)
          || doc.querySelector('product-info')
          || doc.querySelector('[id^="MainProduct-"]');

        if (!newSection) throw new Error('New section container not found in fetched HTML');

        const newMediaWrapper = newSection.querySelector('.product__media-wrapper');
        const newInfoWrapper = newSection.querySelector('.product__info-wrapper');

        if (!currentMediaWrapper || !currentInfoWrapper || !newMediaWrapper || !newInfoWrapper) {
          throw new Error('Wrappers not found');
        }

        // SWAP INVISIBILE
        currentMediaWrapper.replaceWith(newMediaWrapper);
        currentInfoWrapper.replaceWith(newInfoWrapper);

        this.reExecuteScripts(newMediaWrapper);
        this.reExecuteScripts(newInfoWrapper);

        const newStyle = newSection.querySelector('style');
        const currentStyle = currentSection.querySelector('style');
        if (newStyle && currentStyle) {
          currentStyle.textContent = newStyle.textContent;
        }

        const newTitle = doc.querySelector('title');
        if (newTitle) document.title = newTitle.textContent;

        this.dataset.currentUrl = targetUrl;
        this.currentUrl = targetUrl;

        this.reinitMobileCart();
        this.reinitGallery();

        // PULIZIA FORZATA LOADER TEMA
        // Rimuove brutalmente eventuali caricamenti nel caso il tema li abbia attivati
        document.documentElement.classList.remove('loading', 'is-loading', 'page-loading');
        document.body.classList.remove('loading', 'is-loading', 'page-loading', 'overflow-hidden');
        document.querySelectorAll('.loading-overlay, #page-loader, .page-transition, .theme-loader, #transition-loader').forEach(el => {
          if (el) el.style.display = 'none';
        });

      } catch (err) {
        console.error('[Minerva] Swap failed:', err);
        window.location.href = targetUrl;
      } finally {
        this.isSwapping = false;
      }
    }

    reExecuteScripts(container) {
      const scripts = container.querySelectorAll('script');
      scripts.forEach((oldScript) => {
        if (oldScript.type && (oldScript.type.includes('json') || oldScript.type.includes('importmap'))) return;

        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }

    reinitMobileCart() {
      if (window.innerWidth > 749) return;
      const section = document.getElementById(`MainProduct-${this.sectionId}`);
      if (!section) return;

      const wrap = section.querySelector('.minerva-buybtn-wrap');
      if (!wrap) return;

      let mobileCart = document.getElementById('minerva-mobile-cart');
      if (!mobileCart) {
        mobileCart = document.createElement('div');
        mobileCart.id = 'minerva-mobile-cart';
        document.body.appendChild(mobileCart);
      }

      mobileCart.innerHTML = '';
      mobileCart.appendChild(wrap);
      wrap.style.display = '';

      requestAnimationFrame(() => {
        const footerH = mobileCart.offsetHeight;
        document.body.style.paddingBottom = (footerH + 10) + 'px';
      });
    }

    reinitGallery() {
      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        detail: { sectionId: this.sectionId }
      }));
    }
  }

  customElements.define('color-swatch-switcher', ColorSwatchSwitcher);
}
